// extracted by mini-css-extract-plugin
export default {"login":"login_login__XWvWZ","form":"login_form__STWaQ","input":"login_input__CsLCQ","button":"login_button__Z5Z1h"};